import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=e1630f36&scoped=true&"
import script from "./MessageImage.vue?vue&type=script&lang=ts&"
export * from "./MessageImage.vue?vue&type=script&lang=ts&"
import style0 from "./MessageImage.vue?vue&type=style&index=0&id=e1630f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1630f36",
  null
  
)

export default component.exports